class ScreenVideo {
  constructor() {
    this.sections = Array.prototype.slice.call(document.querySelectorAll('.lc-screen-video'));

    if (this.sections.length) {
      this.sections.forEach((section) => this.init(section));
    }
  }

  init(section) {
    this.setupVideo(section);
    this.bindScrollButton(section);
  }

  setupVideo(section) {
    const video = section.querySelector('video');
    const iframe = section.querySelector('iframe');

    if (video) {
      video.loop = false;
      video.removeAttribute('loop');
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.playsInline = true;
      video.autoplay = true;

      const playOnce = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        playOnce();
      } else {
        video.addEventListener('loadeddata', playOnce, { once: true });
      }
    }

    if (iframe) {
      const src = iframe.getAttribute('src');
      if (!src) {
        return;
      }

      iframe.setAttribute('src', this.normalizeEmbedSrc(src));
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    }
  }

  normalizeEmbedSrc(src) {
    try {
      const url = new URL(src, window.location.origin);
      const host = url.hostname;

      if (host.includes('vimeo.com')) {
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('muted', '1');
        url.searchParams.set('background', '1');
        url.searchParams.set('loop', '0');
        url.searchParams.delete('autopause');
      } else if (host.includes('youtube.com') || host.includes('youtu.be')) {
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('loop', '0');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('controls', '0');
      }

      return url.toString();
    } catch (error) {
      return src
        .replace(/([?&])loop=1/g, '$1loop=0')
        .replace(/([?&])loop(?=&|$)/g, '$1loop=0');
    }
  }

  bindScrollButton(section) {
    const button = section.querySelector('.lc-screen-video__scroll');
    if (!button) {
      return;
    }

    button.addEventListener('click', (event) => {
      event.preventDefault();
      const targetTop =
        section.getBoundingClientRect().bottom + window.pageYOffset - this.getScrollOffset();
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth',
      });
    });
  }

  getScrollOffset() {
    const header = document.querySelector('.wp-header');
    let offset = 0;

    if (header) {
      offset += header.getBoundingClientRect().height || 0;
    }

    if (document.documentElement.classList.contains('admin-bar')) {
      offset += window.innerWidth >= 783 ? 32 : 46;
    }

    // Only clear the fixed header — section height already accounts for it,
    // so any extra gap stops the scroll too early.
    return offset;
  }
}

export default ScreenVideo;
